import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import {
  CLIENT_DASHBOARD_ROUTE,
  MACHADALO_DASHBOARD_ROUTE,
} from '../../constants/routes.constants';
import MachadaloRoutes from '../MachadaloDashboard/routes';
import ClientRoutes from '../ClientDashboard/routes';

export default function DashboardRoutes(props) {

  return (
    <Routes>
      <Route path={`machadalo`} element={<MachadaloRoutes />} />
      <Route path={`client`} element={<ClientRoutes />} />
    </Routes>
  );
}
